import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

export function HelpBodyClosedLeadFollowupAutomations() {
    return (
        <OnboardingBody title='Create and assign new leads automatically'>
            <div className='flex flex-dir-col gap-8 pt-16'>
                <Body>
                    Add follow-up rules to a pipeline that will automatically clone a lead with new
                    parameters after it closes
                </Body>
                <Body>Save time from manually duplicating leads</Body>
            </div>
        </OnboardingBody>
    );
}
